/**
 * The layout route element for the parties screens — a `ToastProvider` around an
 * `Outlet`, and deliberately nothing else (the CRF/quotes/work precedent:
 * `routes.tsx` stays metadata so Fast Refresh cannot remount the provider and
 * drop a toast mid-message).
 *
 * The provider arrived WITH the record page: `parties/new` raises no toast (its
 * success navigates or renders the in-page created card — its header records
 * why), but the record page's referral save reports through one, and a
 * mutation whose outcome nothing states would be a silent write.
 */

import { Outlet } from 'react-router-dom';
import { ToastProvider } from '../inquiries/toast';

export function PartyProviders(): React.JSX.Element {
  return (
    <ToastProvider>
      <Outlet />
    </ToastProvider>
  );
}
